import BasePage from "../../components/basePage";
import { Select } from "../../components/select";
import * as Css from "./style";
import { useEdit } from './useEdit';
import ResultTable from "../../components/resultTable";
import UpdateTicketForm from "../../components/form";
import ButtonDefault from "../../ui/Button";
// import { DownloadSpreadsheet } from "../../components/spreadsheet";
import Loader from "../../components/loader";
import { useRef } from "react";

export default function CreateTickets() {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const {
    // searchOptions,
    selectedSearch,
    searchTagOption,
    selectedTag,
    setSelectedTag,
    tags,
    addTag,
    removeTag,
    clearTags,
    setSearchInput,
    searchInput,
    // handleClickSearchOptions,
    totalResponses,
    applyFilter,
    columns,
    results,
    currentPage,
    perPage,
    changePage,

    handleFields,
    handleSubject,
    handleComment,
    handleTypeComment,
    handleStatus,
    handleType,
    handlePriority,
    handleUpdateTickets,

    // downloadListing,
    loading,
    updating,
    updateProgress,
    resetForm,
    handleFileChange,
    failedTickets,
    exportFailedTicketsToXLSX
  } = useEdit();



  const HEADER_LABELS = {
    user: "Usuários",
    ticket: "Tickets",
    organization: "Organizações"
  }
  // type HEADER_TYPE = "user" | "ticket" | "organization";


  return (

    <BasePage>
      <Css.SelectTicketContainer>
        <Css.Row>
          <Css.ColumnSearch>
            <Css.SearchTicketContainer>
              <Css.SearchTop>
                <h1>Edição massiva</h1>
                <p>Tickets</p>
                {/* <Css.SearchOptionsList>
                  {searchOptions.map(option => (
                    <Css.SearchOptionsItem
                      selected={selectedSearch === option}
                      onClick={() => handleClickSearchOptions(option)}>
                      {HEADER_LABELS[option as keyof typeof HEADER_LABELS]}
                    </Css.SearchOptionsItem>
                  ))}
                </Css.SearchOptionsList> */}


              </Css.SearchTop>

              <Css.SearchMiddle>
                <Css.SearchBar>
                  <Select options={searchTagOption} selectedTag={selectedTag} setSelectedTag={setSelectedTag}></Select>
                  <Css.SearchInput
                    type="search"
                    placeholder={selectedTag === "ID" ? "Digite IDs separados por vírgula (ex: 123, 456)" : `Pesquisar por ${selectedTag} do ticket`}
                    value={searchInput || ''}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        addTag();
                        e.currentTarget.value = '';
                      }
                    }}
                  ></Css.SearchInput>
                  {selectedTag === "ID" && (
                    <Css.UploadButtonContainer>
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".txt,.xlsx,.xls"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      <ButtonDefault
                        title="Carregar arquivo de IDs"
                        onClick={() => fileInputRef.current?.click()}
                        color="#6B7280"
                        textColor="white"
                      />
                    </Css.UploadButtonContainer>
                  )}
                  <ButtonDefault title="Aplicar filtro" onClick={() => applyFilter()} color="#2F5BFF" textColor="white" />
                </Css.SearchBar>

                <Css.FilterBar>
                  {tags.map(tag => (
                    <Css.Tag>
                      <Css.TagWrapper>
                        <Css.TagOption>{tag.searchOption}: </Css.TagOption>
                        <Css.TagValue>{tag.value}</Css.TagValue>
                      </Css.TagWrapper>
                      <Css.RemoveTagButton onClick={() => removeTag(tag.ID)}></Css.RemoveTagButton>
                    </Css.Tag>
                  ))}

                  {tags.length > 0 && <Css.RemoveAllTagsButton onClick={() => clearTags()}>Limpar filtros</Css.RemoveAllTagsButton>}
                </Css.FilterBar>
              </Css.SearchMiddle>

            </Css.SearchTicketContainer>

            <Css.ContainerTable className={!results.length? "noContent" : ""}>
              {loading ? (
                <Css.CenterKLoader>
                  <Loader />
                </Css.CenterKLoader>
              ) : !results.length ? (
                <p>Aplique filtros manualmente ou envie uma planilha para visualizar os tickets que deseja editar.</p>
              ) : (
                <Css.ShowTicketContainer>
                  <Css.ResponseHeader>
                    <div id="header-wrapper">
                      <Css.ResponseHeaderOption>{HEADER_LABELS[selectedSearch as keyof typeof HEADER_LABELS]}</Css.ResponseHeaderOption>
                      {totalResponses > 0 && <Css.ResponseHeaderQuantity>{String(totalResponses)}</Css.ResponseHeaderQuantity>}
                    </div>
                    {/* <DownloadSpreadsheet type={selectedSearch as HEADER_TYPE} listing={true} downloadListing={downloadListing} /> */}
                  </Css.ResponseHeader>

                  <ResultTable
                    columns={columns}
                    results={results}
                  />

                  {selectedSearch === "ticket" && totalResponses > perPage && (
                    <Css.PaginationContainer>
                      <ButtonDefault
                        title="Anterior"
                        onClick={() => changePage(currentPage - 1)}
                        color="#2F5BFF"
                        textColor="white"
                        disabled={currentPage === 1}
                      />
                      <Css.PageInfo>
                        Página {currentPage} de {Math.ceil(totalResponses / perPage)}
                      </Css.PageInfo>
                      <ButtonDefault
                        title="Próxima"
                        onClick={() => changePage(currentPage + 1)}
                        color="#2F5BFF"
                        textColor="white"
                        disabled={currentPage >= Math.ceil(totalResponses / perPage)}
                      />
                    </Css.PaginationContainer>
                  )}
                </Css.ShowTicketContainer>
              )}
            </Css.ContainerTable>

          </Css.ColumnSearch>

          <Css.ColumnForms>
            <Css.TicketFormContainer>
              <UpdateTicketForm
                results={results}
                handleSubmit={handleFields}
                handleSubject={handleSubject}
                handleComment={handleComment}
                handleTypeComment={handleTypeComment}
                handleStatus={handleStatus}
                handleType={handleType}
                handlePriority={handlePriority}
                handleUpdateTickets={handleUpdateTickets}
                updating={updating}
                updateProgress={updateProgress}
                key={0}
                resetForm={resetForm}
                failedTickets={failedTickets}
                exportFailedTicketsToXLSX={exportFailedTicketsToXLSX}
              />
            </Css.TicketFormContainer>
          </Css.ColumnForms>
        </Css.Row>
      </Css.SelectTicketContainer>
    </BasePage>
  );
}
